export default {
  common: {
    login: "Login",
    userName: "User name",
    password: "Password",
    rememberPassword: "Remember",
    modifyPassword: "Modify password",
    accountRegister: "Account register",
    pleaseInput: "Please input",
    loginErrorCheckNamePassword: "Login failed, please check username and password",
    guest: "Guest",
    superAdmin: "Super Admin",
    logOut: "Log out",
    inputUserName: "Input User Name",
    inputPassword: "Input Password",
    modifySuccessfully: "Modify password successfully!",

    using: "Using",
    toLogin: "to login",
    noOktaLoginUrl: "No OKTA login url"
  },
  register: {
    email: "E-mail",
    confirmPassword: "Confirm password",
    register: "Register",
    emailRequire: "Email is require",
    passwordRequire: "Password is require",
    confirmPasswordRequire: "Confirm password is require",
    passwordInconsistency: "Password inconsistency",
    registeredSuccessfully: "Registered successfully!",
    jumpToLoginPage: "System will automatically redirect you to the login page.",
    contactAdminActivate: "Please contact the administrator to activate account before you login."
  },
  my: {
    about: "About",
    language: "Language"
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/en.js